import * as __d3ett from "./D3ETemplateTypes";
import GlobalFunctions from "../utils/GlobalFunctions";
import OneTimePassword from "../models/OneTimePassword";
import ResultStatus from "../classes/ResultStatus";
import D3EFeaturebundles from "../classes/D3EFeaturebundles";
import D3EAppTemplateCategories from "../classes/D3EAppTemplateCategories";
import D3EAppTemplate from "../models/D3EAppTemplate";
import ChangePasswordRequest from "../models/ChangePasswordRequest";
import D3EAppTemplateCategoriesRequest from "../models/D3EAppTemplateCategoriesRequest";
import SignUpRequest from "../models/SignUpRequest";
import D3EFeature from "../models/D3EFeature";
import HRMInputFieldType from "../classes/HRMInputFieldType";
import BuilderProject from "../models/BuilderProject";
import D3EFeatureBundle from "../models/D3EFeatureBundle";
import GradientType from "../classes/GradientType";
import LoginResult from "../classes/LoginResult";
import D3EFeaturebundlesRequest from "../models/D3EFeaturebundlesRequest";
import Developer from "../models/Developer";
import D3EAppTemplateCategory from "../models/D3EAppTemplateCategory";
import IconType from "../classes/IconType";
import ConnectionStatus from "../classes/ConnectionStatus";

export const BASEUSER: number = 0;

export const BLOB: number = 1;

export const BOOLEAN: number = 2;

export const BUILDERPROJECT: number = 3;

export const CHANGEPASSWORDREQUEST: number = 4;

export const CONNECTIONSTATUS: number = 5;

export const D3EAPPTEMPLATE: number = 6;

export const D3EAPPTEMPLATECATEGORIES: number = 7;

export const D3EAPPTEMPLATECATEGORIESREQUEST: number = 8;

export const D3EAPPTEMPLATECATEGORY: number = 9;

export const D3EFEATURE: number = 10;

export const D3EFEATUREBUNDLE: number = 11;

export const D3EFEATUREBUNDLES: number = 12;

export const D3EFEATUREBUNDLESREQUEST: number = 13;

export const DFILE: number = 14;

export const DATE: number = 15;

export const DATETIME: number = 16;

export const DEVELOPER: number = 17;

export const DOUBLE: number = 18;

export const DURATION: number = 19;

export const GEOLOCATION: number = 20;

export const GRADIENTTYPE: number = 21;

export const HRMINPUTFIELDTYPE: number = 22;

export const ICONTYPE: number = 23;

export const INTEGER: number = 24;

export const LOGINRESULT: number = 25;

export const ONETIMEPASSWORD: number = 26;

export const RESULTSTATUS: number = 27;

export const SIGNUPREQUEST: number = 28;

export const STRING: number = 29;

export const TIME: number = 30;

export const TYPE: number = 31;

export const VOID: number = 32;

export class D3ETemplate {
  public static HASH: string = "335684fb983b1f2cc95e0ab7592ec809";
  private static _usages: Array<__d3ett.D3EUsage> = [
    new __d3ett.D3EUsage(
      "Query_currentUser_StudioAppsPage_properties_user_computation",
      [
        new __d3ett.D3ETypeUsage(DEVELOPER, [new __d3ett.D3EFieldUsage(0, [])]),
        new __d3ett.D3ETypeUsage(BASEUSER, []),
      ],
      "dc281bd0e5a4b208950f81d39bdc725d"
    ),
    new __d3ett.D3EUsage(
      "Query_getD3EAppTemplateCategories_StudioAppsPage_properties_categoryQuery_computation",
      [
        new __d3ett.D3ETypeUsage(D3EAPPTEMPLATECATEGORIES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(D3EAPPTEMPLATECATEGORY, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(D3EAPPTEMPLATE, [
                  new __d3ett.D3EFieldUsage(0, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, [
                    new __d3ett.D3ETypeUsage(D3EFEATURE, [
                      new __d3ett.D3EFieldUsage(0, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(1, [
                        new __d3ett.D3ETypeUsage(D3EFEATUREBUNDLE, []),
                      ]),
                      new __d3ett.D3EFieldUsage(2, []),
                      new __d3ett.D3EFieldUsage(3, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(3, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "fa0795a7de873592550352e84b4a9cb6"
    ),
    new __d3ett.D3EUsage(
      "Query_getD3EFeaturebundles_StudioFeaturesPage_properties_featureBundleQuery_computation",
      [
        new __d3ett.D3ETypeUsage(D3EFEATUREBUNDLES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(D3EFEATUREBUNDLE, [
              new __d3ett.D3EFieldUsage(1, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "a0ad5ee82a6c191256cea286c57375f6"
    ),
    new __d3ett.D3EUsage(
      "Query_loadDeveloper_StudioAppsPage_properties_user_computation",
      [
        new __d3ett.D3ETypeUsage(DEVELOPER, [new __d3ett.D3EFieldUsage(0, [])]),
        new __d3ett.D3ETypeUsage(BASEUSER, []),
      ],
      "dc281bd0e5a4b208950f81d39bdc725d"
    ),
    new __d3ett.D3EUsage(
      "Query_loginDeveloperUserTypeWithEmailAndPassword_BuilderLoginScreen_eventHandlers_doAuthenticateUser_block",
      [
        new __d3ett.D3ETypeUsage(LOGINRESULT, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(DEVELOPER, [
              new __d3ett.D3EFieldUsage(0, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
        ]),
      ],
      "ae256c0c521fab2b80323248394825e7"
    ),
    new __d3ett.D3EUsage(
      "Query_loginWithOTP_BuilderEmailVerificationView_eventHandlers_onVerifySuccessHandler_block",
      [
        new __d3ett.D3ETypeUsage(LOGINRESULT, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(DEVELOPER, [
              new __d3ett.D3EFieldUsage(0, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
        ]),
      ],
      "ae256c0c521fab2b80323248394825e7"
    ),
    new __d3ett.D3EUsage(
      "Query_loginWithOTP_BuilderForgotScreen_eventHandlers_verifyOTP_block",
      [
        new __d3ett.D3ETypeUsage(LOGINRESULT, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(DEVELOPER, [
              new __d3ett.D3EFieldUsage(0, []),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
        ]),
      ],
      "ae256c0c521fab2b80323248394825e7"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onD3EAppTemplateCategoriesChange_StudioAppsPage_categoryQuery_synchronise",
      [
        new __d3ett.D3ETypeUsage(D3EAPPTEMPLATECATEGORIES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(D3EAPPTEMPLATECATEGORY, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(D3EAPPTEMPLATE, [
                  new __d3ett.D3EFieldUsage(0, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, [
                    new __d3ett.D3ETypeUsage(D3EFEATURE, [
                      new __d3ett.D3EFieldUsage(0, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(1, [
                        new __d3ett.D3ETypeUsage(D3EFEATUREBUNDLE, []),
                      ]),
                      new __d3ett.D3EFieldUsage(2, []),
                      new __d3ett.D3EFieldUsage(3, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(3, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(4, []),
                  new __d3ett.D3EFieldUsage(5, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "fa0795a7de873592550352e84b4a9cb6"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onD3EFeaturebundlesChange_StudioFeaturesPage_featureBundleQuery_synchronise",
      [
        new __d3ett.D3ETypeUsage(D3EFEATUREBUNDLES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(D3EFEATUREBUNDLE, [
              new __d3ett.D3EFieldUsage(1, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "a0ad5ee82a6c191256cea286c57375f6"
    ),
  ];
  private static _types: Array<__d3ett.D3ETemplateType> = [
    new __d3ett.D3ETemplateType(
      "BaseUser",
      "5116c054754a25edc5a13eddbd47e85a",
      [],
      { "abstract": true, "refType": __d3ett.D3ERefType.Model }
    ),
    new __d3ett.D3ETemplateType(
      "Blob",
      "e8016c85ada38bdc5fac616ec1318047",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Boolean",
      "27226c864bac7454a8504f8edb15d95b",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "BuilderProject",
      "5b68c43c5bb8f077e8137e26d150c039",
      [
        new __d3ett.D3ETemplateField(
          "contact",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "features",
          D3EFEATURE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "projectDetails",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "templates",
          D3EAPPTEMPLATE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "website",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new BuilderProject(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ChangePasswordRequest",
      "7bd88617205355840f720948d2b93298",
      [
        new __d3ett.D3ETemplateField(
          "newPassword",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new ChangePasswordRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ConnectionStatus",
      "0d5c2bfbc6b6e414981c0c67321165d5",
      [
        new __d3ett.D3ETemplateField(
          "Connecting",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField("Connected", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField(
          "ConnectionBusy",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "ConnectionNormal",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "ConnectionFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "RestoreFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "AuthFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "D3EAppTemplate",
      "bc19a3b560ca44cc1a70d9b0d26a5856",
      [
        new __d3ett.D3ETemplateField(
          "backgroud",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "description",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "features",
          D3EFEATURE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "icon",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "title",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "topFeatures",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new D3EAppTemplate(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "D3EAppTemplateCategories",
      "66f2a06588190cb861f679f313deeb1b",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          D3EAPPTEMPLATECATEGORY,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new D3EAppTemplateCategories(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "D3EAppTemplateCategoriesRequest",
      "041b5f212b6fdc9107dd500bb03e23e0",
      [
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new D3EAppTemplateCategoriesRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "D3EAppTemplateCategory",
      "b30c5bfed64c88bd1264900d53e5d46a",
      [
        new __d3ett.D3ETemplateField(
          "apps",
          D3EAPPTEMPLATE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true, "inverse": true }
        ),
        new __d3ett.D3ETemplateField(
          "title",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new D3EAppTemplateCategory(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "D3EFeature",
      "bffc8829c8b80d4875844d2a88242dc2",
      [
        new __d3ett.D3ETemplateField(
          "androidScreenshot",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "bundle",
          D3EFEATUREBUNDLE,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "description",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "icon",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "title",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "webScreenshot",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new D3EFeature() }
    ),
    new __d3ett.D3ETemplateType(
      "D3EFeatureBundle",
      "b4c6746f2d9f0d9c9cd7e5f9992fd534",
      [
        new __d3ett.D3ETemplateField(
          "features",
          D3EFEATURE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true, "inverse": true }
        ),
        new __d3ett.D3ETemplateField(
          "title",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new D3EFeatureBundle(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "D3EFeaturebundles",
      "48f4150132fce2208f9dd6a466749e96",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          D3EFEATUREBUNDLE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new D3EFeaturebundles(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "D3EFeaturebundlesRequest",
      "16b9958010e313f9e8a3398477f6e369",
      [
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new D3EFeaturebundlesRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "DFile",
      "71a781845a8ebe8adf67352a573af199",
      [
        new __d3ett.D3ETemplateField("id", STRING, __d3ett.D3EFieldType.String),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "size",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "mimeType",
          STRING,
          __d3ett.D3EFieldType.String
        ),
      ],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Date",
      "44749712dbec183e983dcd78a7736c41",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "DateTime",
      "8cf10d2341ed01492506085688270c1e",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Developer",
      "bdd3552aea58f0dd5852a0ed0da03bf2",
      [
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "parent": 0,
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new Developer(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Double",
      "d909d38d705ce75386dd86e611a82f5b",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Duration",
      "e02d2ae03de9d493df2b6b2d2813d302",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Geolocation",
      "323d4eb70b252acb4a04eaf9e0882597",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "GradientType",
      "dfc80f7e140e2dac94987925914062a8",
      [
        new __d3ett.D3ETemplateField("Color", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField(
          "LinearGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "SweepGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "RadialGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "HRMInputFieldType",
      "c83ed25e708464f4e384a485eff434eb",
      [
        new __d3ett.D3ETemplateField("Rectangle", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Circle", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Underline", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("None", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "IconType",
      "4529ef025543fdd73b83290b6c7b541f",
      [
        new __d3ett.D3ETemplateField("SVG", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Font", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Integer",
      "a0faef0851b4294c06f2b94bb1cb2044",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "LoginResult",
      "43b15c92fa28924318ec2dd9b20d65d3",
      [
        new __d3ett.D3ETemplateField(
          "failureMessage",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "success",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean
        ),
        new __d3ett.D3ETemplateField(
          "token",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "userObject",
          BASEUSER,
          __d3ett.D3EFieldType.Ref
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new LoginResult(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "OneTimePassword",
      "51ff4b4311b22fe068e4103b21e0b0b8",
      [
        new __d3ett.D3ETemplateField(
          "input",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "inputType",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "token",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "userType",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new OneTimePassword(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ResultStatus",
      "b3e4a20b998b614cb3f7bd669946ae7f",
      [
        new __d3ett.D3ETemplateField("Success", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Errors", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "SignUpRequest",
      "439e09e3a74187e9be3ba87ed3f077fb",
      [
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new SignUpRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "String",
      "27118326006d3829667a400ad23d5d98",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Time",
      "a76d4ef5f3f6a672bbfab2865563e530",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Type",
      "a1fa27779242b4902f7ae3bdd5c6d508",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "void",
      "cab8111fd0b710a336c898e539090e34",
      [],
      {}
    ),
  ];
  private static readonly _typeMap: Map<string, number> = Map.fromIterables(
    D3ETemplate._types.map((x) => x.name),
    Array.generate(D3ETemplate._types.length, (index) => index)
  );
  public static allFields(type: number): Array<number> {
    return Array.generate(
      D3ETemplate._types[type].fields.length,
      (index) => index
    );
  }
  public static get types(): Array<__d3ett.D3ETemplateType> {
    return D3ETemplate._types;
  }
  public static get usages(): Array<__d3ett.D3EUsage> {
    return D3ETemplate._usages;
  }
  public static typeString(val: number): string {
    return D3ETemplate._types[val].name;
  }
  public static typeInt(val: string): number {
    return D3ETemplate._typeMap.get(val);
  }
  public static _getField(type: number, val: number): __d3ett.D3ETemplateField {
    let _type: __d3ett.D3ETemplateType = D3ETemplate._types[type];

    /*
_type will have fields with index starting from _type.parentFields.
Anything less needs to be looked up in _type.parent.
*/

    if (val < _type.parentFields) {
      return D3ETemplate._getField(_type.parent, val);
    }

    /*
The field cannot be in _type's child, so subtract _type.parentField from val, and use that as index.
*/

    let adjustedIndex: number = val - _type.parentFields;

    return _type.fields[adjustedIndex];
  }
  public static fieldString(type: number, val: number): string {
    return D3ETemplate._getField(type, val).name;
  }
  public static fieldType(type: number, val: number): number {
    return D3ETemplate._getField(type, val).type;
  }
  public static isChild(type: number, val: number): boolean {
    return D3ETemplate._getField(type, val).child;
  }
  public static fieldInt(type: number, val: string): number {
    let _type: __d3ett.D3ETemplateType = D3ETemplate._types[type];

    if (_type.fieldMap.containsKey(val)) {
      return _type.fieldMap[val];
    }

    if (_type.parent != null) {
      return D3ETemplate.fieldInt(_type.parent, val);
    }

    return null;
  }
  public static isEmbedded(type: number): boolean {
    return D3ETemplate._types[type].embedded;
  }
  public static isAbstract(type: number): boolean {
    return D3ETemplate._types[type].abstract;
  }
  public static hasParent(type: number): boolean {
    return D3ETemplate._types[type].parent != null;
  }
  public static parent(type: number): number {
    return D3ETemplate._types[type].parent;
  }
  public static getEnumField<T>(type: number, field: number): T {
    switch (type) {
      case CONNECTIONSTATUS: {
        return ConnectionStatus.values[field] as unknown as T;
      }

      case GRADIENTTYPE: {
        return GradientType.values[field] as unknown as T;
      }

      case HRMINPUTFIELDTYPE: {
        return HRMInputFieldType.values[field] as unknown as T;
      }

      case ICONTYPE: {
        return IconType.values[field] as unknown as T;
      }

      case RESULTSTATUS: {
        return ResultStatus.values[field] as unknown as T;
      }
    }
  }
}

export class UsageConstants {
  public static readonly QUERY_CURRENTUSER_STUDIOAPPSPAGE_PROPERTIES_USER_COMPUTATION: number = 0;
  public static readonly QUERY_GETD3EAPPTEMPLATECATEGORIES_STUDIOAPPSPAGE_PROPERTIES_CATEGORYQUERY_COMPUTATION: number = 1;
  public static readonly QUERY_GETD3EFEATUREBUNDLES_STUDIOFEATURESPAGE_PROPERTIES_FEATUREBUNDLEQUERY_COMPUTATION: number = 2;
  public static readonly QUERY_LOADDEVELOPER_STUDIOAPPSPAGE_PROPERTIES_USER_COMPUTATION: number = 3;
  public static readonly QUERY_LOGINDEVELOPERUSERTYPEWITHEMAILANDPASSWORD_BUILDERLOGINSCREEN_EVENTHANDLERS_DOAUTHENTICATEUSER_BLOCK: number = 4;
  public static readonly QUERY_LOGINWITHOTP_BUILDEREMAILVERIFICATIONVIEW_EVENTHANDLERS_ONVERIFYSUCCESSHANDLER_BLOCK: number = 5;
  public static readonly QUERY_LOGINWITHOTP_BUILDERFORGOTSCREEN_EVENTHANDLERS_VERIFYOTP_BLOCK: number = 6;
  public static readonly SUBSCRIPTION_OND3EAPPTEMPLATECATEGORIESCHANGE_STUDIOAPPSPAGE_CATEGORYQUERY_SYNCHRONISE: number = 7;
  public static readonly SUBSCRIPTION_OND3EFEATUREBUNDLESCHANGE_STUDIOFEATURESPAGE_FEATUREBUNDLEQUERY_SYNCHRONISE: number = 8;
}

export class ChannelConstants {
  public static readonly Apprunner: number = 0;
  public static readonly APPRUNNER_MESSAGE_COUNT: number = 0;
  public static readonly Rebase: number = 1;
  public static readonly REBASE_MESSAGE_COUNT: number = 0;
  public static readonly Llm: number = 2;
  public static readonly LLM_MESSAGE_COUNT: number = 0;
  public static readonly StudioAI: number = 3;
  public static readonly STUDIOAI_MESSAGE_COUNT: number = 0;
  public static readonly Validation: number = 4;
  public static readonly VALIDATION_MESSAGE_COUNT: number = 0;
  public static readonly Runner: number = 5;
  public static readonly RUNNER_MESSAGE_COUNT: number = 0;
  public static readonly TOTAL_CHANNEL_COUNT: number = 6;
  public static readonly channels: Array<__d3ett.D3ETemplateClass> = [
    new __d3ett.D3ETemplateClass(
      "apprunner",
      "f63b1578cc718223cd3b5959756f3c2e",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "rebase",
      "c16ad6e2f4211c8adae80c725f918731",
      []
    ),
    new __d3ett.D3ETemplateClass("llm", "dae1be85dab3650eb56b87c4e3390387", []),
    new __d3ett.D3ETemplateClass(
      "studioAI",
      "1ce0f5961d28e5d20fc09f9a7efbb4d1",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "validation",
      "a617908b172c473cb8e8cda059e55bf0",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "runner",
      "4bad0b8dd3074cd43f641c2ac22a3571",
      []
    ),
  ];
}

export class RPCConstants {
  public static readonly ProjectService: number = 0;
  public static readonly PROJECTSERVICE_PROCEDURE_COUNT: number = 0;
  public static readonly ClientRunnerService: number = 1;
  public static readonly CLIENTRUNNERSERVICE_PROCEDURE_COUNT: number = 0;
  public static readonly UnsplashRun: number = 2;
  public static readonly UNSPLASHRUN_PROCEDURE_COUNT: number = 0;
  public static readonly StudioService: number = 3;
  public static readonly StudioServicePostLog: number = 0;
  public static readonly STUDIOSERVICE_PROCEDURE_COUNT: number = 1;
  public static readonly UniqueChecker: number = 4;
  public static readonly UniqueCheckerCheckTokenUniqueInOneTimePassword: number = 0;
  public static readonly UniqueCheckerCheckEmailUniqueInDeveloper: number = 1;
  public static readonly UNIQUECHECKER_PROCEDURE_COUNT: number = 2;
  public static readonly FileService: number = 5;
  public static readonly FILESERVICE_PROCEDURE_COUNT: number = 0;
  public static readonly TOTAL_RPC_CLASS_COUNT: number = 6;
  public static readonly classes: Array<__d3ett.D3ETemplateClass> = [
    new __d3ett.D3ETemplateClass(
      "ProjectService",
      "954e90a78b05b9dd5773d46e4ec8b687",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "ClientRunnerService",
      "413438c8999923d13ce9259d73cf5b48",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "UnsplashRun",
      "84b6f0eb8bee7b855541d3490c446140",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "StudioService",
      "63de27fab73437f030dcd905cc99819e",
      [
        new __d3ett.D3ETemplateMethodWithReturn(
          "postLog",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("String"),
          {}
        ),
      ]
    ),
    new __d3ett.D3ETemplateClass(
      "UniqueChecker",
      "a007574d1c5142d448113e44550080ea",
      [
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkTokenUniqueInOneTimePassword",
          [
            new __d3ett.D3ETemplateParam(
              D3ETemplate.typeInt("OneTimePassword"),
              {}
            ),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkEmailUniqueInDeveloper",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Developer"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
      ]
    ),
    new __d3ett.D3ETemplateClass(
      "FileService",
      "e256e0e9ad423eb20c85f506f4580ce8",
      []
    ),
  ];
}
GlobalFunctions.typeInt = D3ETemplate.typeInt;

GlobalFunctions.types = D3ETemplate.types;
